var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _RootComponent_levelName_accessor_storage, _RootComponent_levelAttemptNumber_accessor_storage;
import { LitElement, css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
export var UIState;
(function (UIState) {
    UIState["Title"] = "title";
    UIState["Customizing"] = "customizing";
    UIState["Game"] = "game";
    UIState["Pick"] = "pick";
})(UIState || (UIState = {}));
let RootComponent = class RootComponent extends LitElement {
    constructor() {
        super(...arguments);
        _RootComponent_levelName_accessor_storage.set(this, undefined);
        _RootComponent_levelAttemptNumber_accessor_storage.set(this, undefined);
        this.uiState = UIState.Title;
        // firstUpdated() {
        //     const canvas = this.shadowRoot!.querySelector('canvas')!;
        //     this.dispatchEvent(
        //         new CustomEvent('create-canvas', { detail: canvas })
        //     );
        // }
    }
    get levelName() { return __classPrivateFieldGet(this, _RootComponent_levelName_accessor_storage, "f"); }
    set levelName(value) { __classPrivateFieldSet(this, _RootComponent_levelName_accessor_storage, value, "f"); }
    get levelAttemptNumber() { return __classPrivateFieldGet(this, _RootComponent_levelAttemptNumber_accessor_storage, "f"); }
    set levelAttemptNumber(value) { __classPrivateFieldSet(this, _RootComponent_levelAttemptNumber_accessor_storage, value, "f"); }
    willUpdate(changedProperties) {
        if (changedProperties.has('levelAttemptNumber')) {
            const game = window.game;
            this.uiState = game.inputStarted ? UIState.Game : UIState.Pick;
        }
    }
    render() {
        let uiElems = [];
        if (this.uiState === UIState.Title) {
            uiElems.push(html `<title-component class="fullscreen"></title-component>`);
        }
        if (this.uiState === UIState.Pick) {
            const picker = html `<player-picker
                class="fullscreen"
                levelName="${this.levelName}"
                levelAttemptNumber="${this.levelAttemptNumber}"
                @players-selected=${() => {
                this.uiState = UIState.Game;
            }}
            ></player-picker>`;
            uiElems.push(picker);
        }
        if (this.uiState === UIState.Customizing) {
            const customizer = html `<instructions-component class="fullscreen"></instructions-component>`;
            uiElems.push(customizer);
        }
        return html `
            <canvas class="main-canvas"></canvas>
            ${uiElems}
        `;
    }
};
_RootComponent_levelName_accessor_storage = new WeakMap();
_RootComponent_levelAttemptNumber_accessor_storage = new WeakMap();
RootComponent.styles = css `
        :host {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100vh;
            width: 100vw;
        }

        .fullscreen {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 1;
        }
    `;
__decorate([
    property({ type: String })
], RootComponent.prototype, "levelName", null);
__decorate([
    property({ type: Number })
], RootComponent.prototype, "levelAttemptNumber", null);
__decorate([
    state()
], RootComponent.prototype, "uiState", void 0);
RootComponent = __decorate([
    customElement('root-component')
], RootComponent);
export { RootComponent };
// declare global {
//     interface HTMLElementEventMap {
//         'create-canvas': CustomEvent<HTMLCanvasElement>;
//     }
// }
